import React, {useState} from 'react';
import {Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import businessHelper from "../../helpers/BusinessHelper";
import IncomeReportRow from "./IncomeReportRow";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const IncomeReport = (props) => {
    const [data, setData] = useState(props.data);
    const [currency, setCurrency] = useState(businessHelper.currency());

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    localize();

    function renderTableData() {
        if (data !== null) {
            return data.map((income, index) => {
                return (
                    <IncomeReportRow income={income} key={income.id} openTicket={{}} deleteTicket={{}}
                                     strings={resourceStrings} currency={currency}/>
                )
            })
        }
    }

    return (
        <Table
            className="align-items-center table-dark table-flush"
            responsive
        >
            <thead className="thead-dark">
            <tr>
                <th scope="col">{resourceStrings.title}</th>
                <th scope="col">{resourceStrings.category}</th>
                <th scope="col">{commonStrings.date}</th>
                <th scope="col">{resourceStrings.price}</th>
                <th scope="col" className="text-right">{commonStrings.payment_method}</th>
            </tr>
            </thead>
            <tbody>
            {renderTableData()}
            </tbody>
        </Table>
    );
};

export default IncomeReport;